export const SHIFT_SETTING_FLAGS = {
  DUTY_CATEGORY_WORK: 1,
  // DUTY_CATEGORY_ABSENCE: 2,
  DUTY_CATEGORY_OTHER: 3,
};

export const SHIFT_SETTING_PAGES = {
  DUTY_DESCRIPTION: 'シフトの時間に紐づく業務内容の設定を行います。',
  STAFFING_LEVEL_FACILITY_DESCRIPTION:
    '上記の年齢別配置数をもとに計算した必要配置数の合計に、施設全体で追加したい保育士数を設定します。',
  WORKPLACES_DESCRIPTION:
    '業務をどこで行っているかの場所の設定を行います。設定された持ち場に基づき配置数が算出されます。',
  SHIFT_CATEGORY_DESCRIPTION: 'シフトカテゴリおよびパターンの設定を行います',
  STAFFING_LEVEL_BY_AGE_DESCRIPTION:
    '園児の年齢ごとに、保育士一人あたりの園児数および追加で配置する保育士数を設定します。',
  STAFFING_LEVEL_BY_COMBINE_AGE_DESCRIPTION:
    '１・2歳児、4・5歳児については合算し、保育士一人あたりの園児数および追加で配置する保育士数を設定します。',
  STAFFING_LEVEL_BY_AGE_COMMON_DESCRIPTION:
    '保育を実施していない年齢については、一人あたりの園児数を0にする必要はありません。',
};
